// this file added by Bearer Web Developer
import React from 'react';
import { observer } from 'mobx-react-lite';
import { Button, Dialog } from '@mui/material';
import styles from './completeProfilePopup.module.scss';
import { useAppState } from '../../states/app-state';
import ProfileForm from './profileForm';
import Congratulations from './congratulations';
import { useThemeMode } from '../../states/contexts/theme';

interface Props {
    open: boolean
}
const CompleteProfilePopup: React.FunctionComponent<Props> = observer(({ open }) => {
    const appState = useAppState();
    const { completeProfile, createAccount } = appState;
    const sign_up_stage = appState?.createAccount?.sign_up_stage;

    const handleClose = () => {
        if (sign_up_stage === 3) {
            window.location.reload();
            completeProfile?.setOpen(false);
        } else {
            // sign_up_stage = 2
            if (createAccount?.complete_registeration) return;
            completeProfile?.setOpen(false);
        }
    }
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    return (
        <Dialog open={open}
            slotProps={{
                paper: {
                    sx: {
                        borderRadius: "10px",
                        backgroundColor: theme === "dark" ? 'var(--neutral-hsb-30, #4D4D4D)' : '#fff'
                    },
                    classes: { root: styles.root }
                },
            }}
            onClose={handleClose}>
            {
                sign_up_stage === 3 ? <Congratulations /> :
                    <div className={styles.main_content} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
                        <header>
                            <h5>Complete Your Profile</h5>
                            <Button className={styles.cancel} onClick={handleClose}><img src="/cancel.png" alt="X" width={28} height={28} /></Button>
                        </header>
                        <p>Complete your profile to unlock all the exciting features of Bearer!</p>
                        <ProfileForm />
                    </div>
            }
        </Dialog>
    );
});
export default CompleteProfilePopup;
